<template lang="pug">
.toggle-sort(@click='changeSort', :data-direction='direction')
  .toggle-sort__label.font-bold
    slot
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { SortSettings, SortSetting } from '@/const/SortSettings'

/**
 * ソート用トグルボタン
 */
@Component
export default class ToggleSort extends Vue {
  // 昇順フラグ
  @Prop()
  sortSetting!: SortSetting

  private changeSort() {
    this.$emit('change-sort', SortSettings[this.sortSetting.nextSort])
  }

  private get direction() {
    return this.sortSetting.directionChar
  }
}
</script>

<style lang="stylus" scoped>
.toggle-sort
  position relative
  display inline-block
  padding-right 20px
  cursor pointer

  &::before
    position absolute
    top 20%
    right 0
    content ''
    border-left 6px solid transparent
    border-right 6px solid transparent
    border-bottom 6px solid

  &::after
    position absolute
    bottom 20%
    right 0
    content ''
    border-left 6px solid transparent
    border-right 6px solid transparent
    border-top 6px solid

  &[data-direction='up']
    &::before
      border-bottom-color var(--color-manager-sort__active)
    &::after
      border-top-color var(--color-manager-sort__inactive)

  &[data-direction='down']
    &::before
      border-bottom-color var(--color-manager-sort__inactive)
    &::after
      border-top-color var(--color-manager-sort__active)

  &[data-direction='none']
    &::before
      border-bottom-color var(--color-manager-sort__inactive)
    &::after
      border-top-color var(--color-manager-sort__inactive)
</style>
